/*
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-04-15 13:35:57
 * @LastEditors: linwc
 * @LastEditTime: 2025-06-11 15:31:10
 * @FilePath: /ryGitLab/lysorasurvey/src/api/nps.js
 */
import { requestHttp } from '@/utils';

const SERVER = ``;
// 方案的区域
const schemesApi = {
  surveyApi: `${SERVER}/user/submit_survey`,
  querySurveyApi: `${SERVER}/user/query_survey`,
  askSurveyApi: `${SERVER}/user/ask_survey`,
  missionQuerySurveyApi: `${SERVER}/user/mission/query_survey`, // 任务级
  missionSurveyApi: `${SERVER}/user/mission/submit_survey` // 任务级
};

//nps打分
export const postSurveyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.surveyApi,
    method: 'POST',
    module: 'nps',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

//nps基本项获取
export const postQuerySurveyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.querySurveyApi,
    method: 'POST',
    module: 'nps',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

// 获取nps是否打开
export const postAskSurveyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.askSurveyApi,
    method: 'POST',
    module: 'nps',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

/**
 * @name: linwc
 * @msg: nps打分 - 任务级
 * @param {*} data
 * @return {*}
 */
export const postMissionSurveyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.missionSurveyApi,
    method: 'POST',
    module: 'nps',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

/**
 * @name: linwc
 * @msg: nps基本项获取 - 任务级
 * @param {*} data
 * @return {*}
 */
export const postMissionQuerySurveyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.missionQuerySurveyApi,
    method: 'POST',
    module: 'nps',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};
